import { FC, HTMLInputTypeAttribute, InputHTMLAttributes } from 'react';
import { Field } from 'formik';

export interface TextareaProps extends InputHTMLAttributes<HTMLInputElement> {
  className?: string;
  disabled?: boolean;
  value?: string;
  touched?: any;
  type?: HTMLInputTypeAttribute;
  name?: string;
  placeholder?: string;
  error?: string;
  label?: string;
  cols?: string;
  rows?: string;
  max?: string;
  required?: boolean;
  headText?: string;
}

const Textarea: FC<TextareaProps> = ({
  className,
  disabled,
  value,
  touched,
  type,
  name,
  placeholder,
  error,
  label,
  cols,
  rows,
  max,
  headText,
  ...rest
}) => (
  <>
    <div>
      {label && (
        <label className="text-white text-lg mb-2" htmlFor={name}>
          {label}
        </label>
      )}
      {headText && (
        <p className="text-white opacity-75 text-xs my-4">{headText}</p>
      )}
      <Field
        value={value}
        name={name}
        id={name}
        type={type}
        placeholder={placeholder}
        disabled={disabled}
        className={`${
          touched && touched[name as string] && error
            ? 'border-red-500'
            : touched && touched[name as string] && ''
        } ${className} w-full`}
        {...rest}
        as="textarea"
        cols={cols}
        rows={rows}
        maxLength={max}
      />
      <div className="flex justify-between">
        {error && touched && (
          <p className="text-red-700 text-xs my-4">{error}</p>
        )}

        {max ? (
          <div className="text-white flex justify-end opacity-75 text-xs">
            Max: {max} words
          </div>
        ) : (
          ''
        )}
      </div>
    </div>
  </>
);

export default Textarea;
